import { UrlHandlingStrategy, UrlTree } from '@angular/router';
import {FarmnetModuleService} from './farmnet-module.service';
import { Injectable, Injector } from '@angular/core';
import * as angular from 'angular';
import { FNW_NAVIGATION_ROUTE } from '@farmnet/webapp-loader-companion';

@Injectable({
    providedIn: 'root'
})
export class Ng1NgxUrlHandlingStrategyService implements UrlHandlingStrategy {

  constructor(private fms:FarmnetModuleService, private injector: Injector) {}

  extract(url: UrlTree): UrlTree {
    return url;
  }

  merge(newUrlPart: UrlTree, rawUrl: UrlTree): UrlTree {
    return newUrlPart;
  }

  extracModuleName(url: UrlTree | string): string {
    let match = url.toString().match(/\/([^/]*)/);
    return match ? match[1] : '';
  }

  shouldProcessUrl(url: UrlTree | string): boolean {
    const urlString = url.toString();

    return urlString === '/' + FNW_NAVIGATION_ROUTE ||  urlString === '/test-service' || this.fms.hasNgxModule(this.extracModuleName(url));
  }

  isAngularRoute() {
    try {
      const $location = this.injector.get('$location') as angular.ILocationService;
      return this.shouldProcessUrl($location.url());
    } catch (e) {
      // $location not found
      return true;
    }
  }
}
